import Resource from './Resource';

export default class ClassPageLog extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {},
		} = options;

		let config = {
			route: 'class-pages/:courseSectionGuid/activity-logs',
			query: query,
			data: data,
			routeParams: routeParams,
		};
		super(config);
		return this;
	}

	post() {
		return this.request("post");
	}
}
